"use strict";

exports.__esModule = true;
exports.LogbookList = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _TicketingContext = require("../Ticketing/TicketingContext");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var StyledList = _styledComponents["default"].ul.withConfig({
  displayName: "LogbookList__StyledList",
  componentId: "sc-1u7hr6a-0"
})(["padding:0;margin:0;list-style:none;"]);
var LogbookList = exports.LogbookList = function LogbookList(props) {
  var reload = props.reload,
    children = props.children;
  var _React$useContext = _react["default"].useContext(_TicketingContext.TicketingContext),
    lastCreatedTicket = _React$useContext.lastCreatedTicket;
  var _useState = (0, _react.useState)(lastCreatedTicket),
    prevLastCreatedTicket = _useState[0],
    setPrevLastCreatedTicket = _useState[1];
  (0, _react.useEffect)(function () {
    if (prevLastCreatedTicket !== lastCreatedTicket) {
      reload();
      setPrevLastCreatedTicket(lastCreatedTicket);
    }
  }, [lastCreatedTicket]);
  return /*#__PURE__*/_react["default"].createElement(StyledList, null, children);
};